import { ChevronUp } from "@roman/shared/components/Icons";
import { cn } from "@roman/shared/utils";
import DOMPurify from "dompurify";

interface DescriptionProps {
  showDescription: boolean;
  setShowDescription: (visible: boolean) => void;
  description: string;
}

const Description = ({ showDescription, setShowDescription, description }: DescriptionProps) => {
  return (
    <div>
      <div
        className="flex justify-end items-center"
        onClick={() => {
          setShowDescription(!showDescription);
        }}
      >
        <div className="flex gap-[7px] items-center justify-center cursor-pointer">
          <div className="text-right font-medium text-[12px] leading-[17.88px] tracking-tighter text-secondary">
            クイズのルールを見る
          </div>
          <ChevronUp
            className={cn(
              "text-secondary transition-transform duration-300",
              showDescription ? "rotate-0" : "rotate-180",
            )}
          />
        </div>
      </div>

      {showDescription && (
        <div className="mt-3">
          <div className="font-normal text-[12px] leading-[18px] text-dark-gray px-[14px] py-4 bg-thin-gray rounded-[6px]">
            <pre className="whitespace-pre-wrap break-words">
              {typeof description === "string" ? (
                // biome-ignore lint/security/noDangerouslySetInnerHtml: From admin panel trust input source
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
              ) : (
                description
              )}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};
export default Description;
